import { Instance } from 'mobx-state-tree';
import { TeamMemberDeletedDtoModelBase } from './TeamMemberDeletedDtoModel.base';

/* The TypeScript type of an instance of TeamMemberDeletedDtoModel */
export interface TeamMemberDeletedDtoModelType extends Instance<typeof TeamMemberDeletedDtoModel.Type> {}

/* A graphql query fragment builders for TeamMemberDeletedDtoModel */
export { selectFromTeamMemberDeletedDto, teamMemberDeletedDtoModelPrimitives, TeamMemberDeletedDtoModelSelector } from './TeamMemberDeletedDtoModel.base';

/**
 * TeamMemberDeletedDtoModel
 */
export const TeamMemberDeletedDtoModel = TeamMemberDeletedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
